import { render, staticRenderFns } from "./AnimateShape.vue?vue&type=template&id=4bad3680"
import script from "./AnimateShape.vue?vue&type=script&lang=js"
export * from "./AnimateShape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports